var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.5 41.5",
    style: {
      enableBackground: "new 0 0 41.5 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C4C4C4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.75,
    cy: 20.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.01,13.16v3.18h2.19v-4.27c0-0.6-0.49-1.09-1.09-1.09h-4.02v2.19H29.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.49,13.16h2.93v-2.19h-4.02c-0.6,0-1.09,0.49-1.09,1.09v4.27h2.19V13.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.49,28.34v-3.18H10.3v4.27c0,0.6,0.49,1.09,1.09,1.09h4.02v-2.19H12.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.01,28.34h-2.93v2.19h4.02c0.6,0,1.09-0.49,1.09-1.09v-4.27h-2.19V28.34z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,17.67c-0.12-0.07-0.26-0.06-0.38,0.01l-2.39,1.49v-1.81c0-0.39-0.31-0.7-0.7-0.7H15.1 c-0.39,0-0.7,0.31-0.7,0.7v6.78c0,0.39,0.31,0.7,0.7,0.7h8.33c0.39,0,0.7-0.31,0.7-0.7v-1.72l2.4,1.4 c0.06,0.03,0.12,0.05,0.19,0.05c0.06,0,0.13-0.02,0.19-0.05c0.12-0.07,0.19-0.19,0.19-0.32V18C27.1,17.86,27.02,17.74,26.9,17.67z "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon_6.923b78ea628039abc55a0606ffe2c05a.svg";
export { ForwardRef as ReactComponent };